var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdlerGuideWasd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 237 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fadeea;stroke:#db1f72;stroke-miterlimit:10;stroke-width:4px;}.cls-2,.cls-3{font-size:36.11px;font-family:ArialMT, Arial;}.cls-2,.cls-3,.cls-4{fill:#db1f72;}.cls-3{letter-spacing:-0.06em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84,
    y: 2,
    width: 71,
    height: 71,
    rx: 14.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84,
    y: 83,
    width: 71,
    height: 71,
    rx: 14.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 83,
    width: 71,
    height: 71,
    rx: 14.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 164,
    y: 83,
    width: 71,
    height: 71,
    rx: 14.69
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(102.92 51.69)"
  }, "W"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(109.92 131.69)"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(187.92 131.69)"
  }, "D"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(24.92 131.69)"
  }, "A"), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M582.37,458.87v-7.39l-1.51,1.94v-1.55l1.93-2.72,2,2.72v1.55l-1.53-1.94v7.39Z",
    transform: "translate(-441 -441)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M581.08,534.76v7.4l1.95-1.95v1.55l-2.49,2.73L578,541.76v-1.55l2,1.95v-7.4Z",
    transform: "translate(-441 -441)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M658.22,538.16h7.4l-2-1.94h1.55L668,538.7l-2.73,2.57h-1.55l2-1.95h-7.4Z",
    transform: "translate(-441 -441)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M503.55,537.32h-7.4l2,1.95h-1.55l-2.73-2.49,2.73-2.57h1.55l-2,2h7.4Z",
    transform: "translate(-441 -441)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdlerGuideWasd);
export default __webpack_public_path__ + "static/media/adler_guide_WASD.13c700d5fb2e794e65330e4b83c2630d.svg";
export { ForwardRef as ReactComponent };